import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { LazyImage } from '~/components/LazyImage';
import { TIKTOK_PREVIEW_ASPECT_RATIO } from '~/constants';
import { tiktokType } from '~/types';

import { LazyVideo } from '../LazyVideo';

export const TiktokPreviewCard = ({
  alt = 'Tiktok video preview',
  item,
  contentPreviewedId,
  canPlayVideo,
  borderRadius = { base: 'sm', sm: 'md', md: 'lg' },
}) => {
  const [asset] = item.assets ?? [];
  return (
    <>
      <Box borderRadius={borderRadius} overflow="hidden">
        {canPlayVideo ? (
          <LazyVideo
            ratio={TIKTOK_PREVIEW_ASPECT_RATIO}
            containerProps={{
              id: contentPreviewedId,
            }}
            src={asset?.url}
            showPlayIcon={true}
            videoProps={{ alt, poster: asset?.previewUrl, maxWidth: 'initial' }}
          />
        ) : (
          <LazyImage
            ratio={TIKTOK_PREVIEW_ASPECT_RATIO}
            src={asset?.previewUrl}
            imageProps={{ alt, id: contentPreviewedId }}
          />
        )}
      </Box>
    </>
  );
};

TiktokPreviewCard.propTypes = {
  item: tiktokType,
  alt: PropTypes.string,
  contentPreviewedId: PropTypes.string,
  canPlayVideo: PropTypes.bool,
  borderRadius: PropTypes.oneOfType([
    PropTypes.shape(),
    PropTypes.number,
    PropTypes.string,
  ]),
};
